import React from 'react';
import { PageId } from '@common/constants';

const Homepage = React.lazy(() => import('../pages/Homepage'));
const ActiveEvent = React.lazy(() => import('../pages/ActiveEvent/ActiveEvent1'));
const ActiveEvent2 = React.lazy(() => import('../pages/ActiveEvent/ActiveEvent2'));
const AboutUs = React.lazy(() => import('../pages/About/AboutUs'));
const MissionVision = React.lazy(() => import('../pages/About/MissionVision'));
const BoardOfAdvisors = React.lazy(() => import('../pages/About/BoardOfAdvisors'));
const ExecutiveCouncil = React.lazy(() => import('../pages/About/ExecutiveCouncil'));
const IndustrialExpertAdvisory = React.lazy(
	() => import('../pages/About/IndustrialExpertAdvisory')
);
const Events = React.lazy(() => import('../pages/Events/Events'));
const EventsGallery = React.lazy(() => import('../pages/Events/EventsGallery'));
const Video = React.lazy(() => import('../pages/Events/Video'));
const Homecoming = React.lazy(() => import('../pages/Events/Homecoming'));
const CallToReform = React.lazy(() => import('../pages/News/CallToReform'));
const TAAEducationTrust = React.lazy(() => import('../pages/News/TAAEducationTrust'));
const NewsRelease = React.lazy(() => import('../pages/News/NewsRelease'));
const NewsClippings = React.lazy(() => import('../pages/News/NewsClippings'));
const AlumniNewsClippings = React.lazy(() => import('../pages/News/AlumniNewsClippings'));
const Membership = React.lazy(() => import('../pages/Membership/Membership'));
const JoinUs = React.lazy(() => import('../pages/Membership/JoinUs'));
const TCCI = React.lazy(() => import('../pages/TCCI'));
const TARUCTAAScholarships = React.lazy(() => import('../pages/TARUCTAAScholarships'));
const RegionalCharter = React.lazy(() => import('../pages/Charter/RegionalCharter'));
const SouthCharter = React.lazy(() => import('../pages/Charter/SouthCharter'));
const ContactUs = React.lazy(() => import('../pages/Contact/ContactUs'));
const Donation = React.lazy(() => import('../pages/Contact/Donation'));
const PrivacyPolicy = React.lazy(() => import('../pages/Membership/PrivacyPolicy'));
const COTBook = React.lazy(() => import('../pages/COTBook'));

export const routes = [
	{
		page: {
			parentId: PageId.Homepage,
			selfId: PageId.Homepage,
		},
		title: 'Home',
		path: '/',
		component: Homepage,
		bgClass: 'bg-transparent',
	},
	{
		page: {
			parentId: PageId.Homepage,
			selfId: PageId.Homepage,
		},
		title: 'Home',
		path: '*',
		exact: false,
		component: Homepage,
		bgClass: 'bg-1',
	},
	{
		page: {
			parentId: PageId.ActiveEvent1,
			selfId: PageId.ActiveEvent1,
		},
		title: 'Active Event 1',
		exact: true,
		path: '/active-event',
		component: ActiveEvent,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.ActiveEvent2,
			selfId: PageId.ActiveEvent2,
		},
		title: 'Active Event 2',
		exact: true,
		path: '/active-event-2',
		component: ActiveEvent2,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.AboutUs,
			selfId: PageId.AboutUs,
		},
		title: 'About Us',
		exact: true,
		path: '/about-us',
		component: AboutUs,
		bgClass: 'bg-transparent',
	},
	{
		page: {
			parentId: PageId.AboutUs,
			selfId: PageId.MissionVision,
		},
		title: 'Mission & Vision',
		exact: true,
		path: '/mission-vision',
		component: MissionVision,
		bgClass: 'bg-3',
	},
	{
		page: {
			parentId: PageId.AboutUs,
			selfId: PageId.BoardOfAdvisors,
		},
		title: 'Board of Advisors',
		exact: true,
		path: '/board-of-advisors',
		component: BoardOfAdvisors,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.AboutUs,
			selfId: PageId.ExecutiveCouncil,
		},
		title: 'Executive Council Office Bearers',
		exact: true,
		path: '/executive-council',
		component: ExecutiveCouncil,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.AboutUs,
			selfId: PageId.IndustrialExpertAdvisory,
		},
		title: 'Industrial Expert Advisory Committee',
		exact: true,
		path: '/industrial-expert-advisory',
		component: IndustrialExpertAdvisory,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.Events,
			selfId: PageId.Events,
		},
		title: 'Events',
		exact: true,
		path: '/events',
		component: Events,
		bgClass: 'bg-4',
	},
	{
		page: {
			parentId: PageId.Events,
			selfId: PageId.EventsGallery,
		},
		title: 'Events Gallery',
		exact: true,
		path: '/events-gallery',
		component: EventsGallery,
		bgClass: 'bg-5',
	},
	{
		page: {
			parentId: PageId.Events,
			selfId: PageId.Video,
		},
		title: 'Video',
		exact: true,
		path: '/video',
		component: Video,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.Events,
			selfId: PageId.Homecoming,
		},
		title: 'Homecoming',
		exact: true,
		path: '/homecoming',
		component: Homecoming,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.News,
			selfId: PageId.CallToReform,
		},
		header: 'Notice',
		title: 'Call to Reform TARC Education Foundation',
		exact: true,
		path: '/call-to-reform',
		component: CallToReform,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.News,
			selfId: PageId.TAAEducationTrust,
		},
		title: 'TAA Education Trust Fund',
		exact: true,
		path: '/taa-education-trust',
		component: TAAEducationTrust,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.News,
			selfId: PageId.NewsRelease,
		},
		title: 'News Release',
		exact: true,
		path: '/news-release',
		component: NewsRelease,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.News,
			selfId: PageId.NewsClippings,
		},
		title: 'News Clippings',
		exact: true,
		path: '/news-clippings',
		component: NewsClippings,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.News,
			selfId: PageId.AlumniNewsClippings,
		},
		title: 'Alumni News Clippings',
		exact: true,
		path: '/alumni-news-clippings',
		component: AlumniNewsClippings,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.Membership,
			selfId: PageId.Membership,
		},
		title: 'Membership',
		exact: true,
		path: '/membership',
		component: Membership,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.Membership,
			selfId: PageId.JoinUs,
		},
		title: 'Join Us',
		exact: true,
		path: '/join-us',
		component: JoinUs,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.Membership,
			selfId: PageId.TAAPrivacyPolicy,
		},
		title: 'Privacy Policy',
		exact: true,
		path: '/privacy-policy',
		component: PrivacyPolicy,
		bgClass: 'bg-2',
	},
	{
		page: {
			parentId: PageId.TCCI,
			selfId: PageId.TCCI,
		},
		title: 'TCCI',
		exact: true,
		path: '/tcci',
		component: TCCI,
		bgClass: 'bg-8',
	},
	{
		page: {
			parentId: PageId.TARUCTAAScholarships,
			selfId: PageId.TARUCTAAScholarships,
		},
		title: 'TARUC-TAA Scholarships',
		exact: true,
		path: '/taruc-taa-scholarships',
		component: TARUCTAAScholarships,
		bgClass: 'bg-6',
	},
	{
		page: {
			parentId: PageId.RegionalCharter,
			selfId: PageId.RegionalCharter,
		},
		title: 'Regional Charter',
		exact: true,
		path: '/regional-charter',
		component: RegionalCharter,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.RegionalCharter,
			selfId: PageId.SouthCharter,
		},
		title: 'South Charter',
		exact: true,
		path: '/south-charter',
		component: SouthCharter,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.ContactUs,
			selfId: PageId.ContactUs,
		},
		title: 'Contact Us',
		exact: true,
		path: '/contact-us',
		component: ContactUs,
		bgClass: 'bg-7',
	},
	{
		page: {
			parentId: PageId.ContactUs,
			selfId: PageId.Donation,
		},
		title: 'Donation',
		exact: true,
		path: '/donation',
		component: Donation,
		bgClass: 'bg-0',
	},
	{
		page: {
			parentId: PageId.COTBook,
			selfId: PageId.COTBook,
		},
		title: 'COTBook',
		exact: true,
		path: '/cot-book',
		component: COTBook,
		bgClass: 'bg-2',
	},
];
